module.exports = __webpack_public_path__ + "static/evento-057ff98148db3f4d500c186e5b9318ec.jpg";